module.exports = __webpack_public_path__ + "static/5_web_gelistirme-7b34bf9d0ea7382283953db67d0c2b11.webp";